var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 56,
    viewBox: "0 0 129 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.609 37.0195V28.6265C122.609 23.9156 118.841 19.9993 114.13 19.9761C109.398 19.9528 105.543 23.8078 105.566 28.5406C105.589 33.2514 109.505 37.0195 114.216 37.0195H122.609ZM114.088 14.2949C121.931 14.2949 128.291 20.6535 128.291 28.4977V42.7005H114.088C106.243 42.7005 99.8848 36.3417 99.8848 28.4977C99.8848 20.6535 106.243 14.2949 114.088 14.2949Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3633 42.7002H97.0442V14.2944H91.3633V42.7002Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0442 8.61404C97.0442 10.1829 95.7724 11.4546 94.2036 11.4546C92.6349 11.4546 91.3633 10.1829 91.3633 8.61404C91.3633 7.0452 92.6349 5.77344 94.2036 5.77344C95.7724 5.77344 97.0442 7.0452 97.0442 8.61404Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7774 33.8975C70.8062 35.0564 72.0697 36.0125 73.5667 36.7663C75.0641 37.5203 76.5098 37.9018 77.9051 37.9121C79.4073 37.9235 80.6438 37.5708 81.6142 36.8538C82.5851 36.137 83.0734 35.3705 83.0789 34.5532C83.0851 33.6997 82.7944 33.0107 82.2081 32.4859C81.6215 31.9622 80.7919 31.6036 79.7204 31.4094L76.559 30.7734C73.0579 30.079 70.6326 29.1239 69.2819 27.9066C67.9303 26.6905 67.2626 25.0609 67.2768 23.0185C67.2935 20.6056 68.228 18.5421 70.0826 16.8296C71.936 15.1168 74.4192 14.2718 77.5311 14.2949C79.3551 14.3084 81.0875 14.6191 82.729 15.2248C84.3697 15.8312 86.0624 16.7905 87.8064 18.1027L86.1724 20.1708L84.6129 22.1447C83.3682 21.0215 82.1583 20.2329 80.9807 19.7787C79.8035 19.3244 78.6963 19.0932 77.6591 19.0855C76.3714 19.076 75.2509 19.3742 74.2994 19.9798C73.3471 20.5853 72.8679 21.4084 72.8607 22.4474C72.8505 23.9328 73.9706 24.888 76.2209 25.3128L81.8469 26.4684C86.4186 27.3936 88.6916 29.805 88.6648 33.7038C88.6576 34.7435 88.4359 35.7904 87.9992 36.8453C87.5626 37.9003 86.8939 38.8795 85.994 39.7822C85.0931 40.6861 83.9347 41.4015 82.5183 41.9284C81.1015 42.456 79.4635 42.7136 77.6039 42.6995C73.3831 42.6682 69.4947 41.062 65.9404 37.8791L69.7774 33.8975Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.805 0.00181491C22.2118 0.0649083 17.0077 1.77758 12.6557 4.67334L13.6802 5.97067C17.9091 3.18803 22.982 1.58793 28.4253 1.64878C42.4763 1.80577 54.0117 13.0883 54.465 27.1327C54.9559 42.348 42.4735 54.8304 27.2583 54.339C13.2141 53.8856 1.93173 42.35 1.77475 28.2992C1.71408 22.8558 3.31419 17.7831 6.09646 13.5542L4.79932 12.5297C1.90336 16.8817 0.190882 22.0858 0.127788 27.6791C-0.0448787 42.9821 12.1508 55.647 27.4808 55.9927C43.4442 56.3528 56.479 43.3181 56.1188 27.3547C55.7728 12.0247 43.1078 -0.171039 27.805 0.00181491Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6553 8.78418C11.6553 10.3003 10.4263 11.5293 8.91016 11.5293C7.39405 11.5293 6.16504 10.3003 6.16504 8.78418C6.16504 7.26808 7.39405 6.03906 8.91016 6.03906C10.4263 6.03906 11.6553 7.26808 11.6553 8.78418Z",
    fill: "#ADB7D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3613 28.0003V36.2357H28.126C23.5777 36.2357 19.8906 32.5486 19.8906 28.0003C19.8906 23.4521 23.5777 19.765 28.126 19.765C32.6741 19.765 36.3613 23.4521 36.3613 28.0003ZM28.2298 14.2753C20.6018 14.2187 14.4004 20.3852 14.4004 28.0003C14.4004 35.5807 20.5455 41.7258 28.126 41.7258H41.8515V28.1726C41.8515 20.6045 35.7979 14.3313 28.2298 14.2753Z",
    fill: "#ADB7D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 56,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSia);
export default __webpack_public_path__ + "static/media/sia.2e4ff7318123b08352882941bfdf3d85.svg";
export { ForwardRef as ReactComponent };